import React from "react";
import { Box, Typography, Container, Grid } from "@mui/material";

function HelpUs() {
  return (
    <Box>
      {/* Móduclo Banner */}
      <Box
        sx={{
          width: "100%",
          height: { xs: 220, sm: 320, md: 380 },
          overflow: "hidden",
        }}
      >
        <Box
          component="img"
          src="/images/banner2.jpeg"
          alt="Ajuda Banner"
          sx={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </Box>

      <br></br>
      <br></br>


      <Container maxWidth="lg" sx={{ paddingLeft: "100px" }}>
        {/* Módulo Informaciones */}
        <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: "bold", color: '#383838' }}>
        Nos Ayude
        </Typography>
        <Typography variant="body1" align="center" gutterBottom sx={{ fontSize: '14px' }}>
        Hay varias maneras de ayudarnos. Todo el dinero que recibimos se destina exclusivamente al cuidado de los gatos que tenemos bajo nuestra protección.<br/>
        Los gastos son elevados y las facturas veterinarias, numerosas. Este primer importe recaudado se destinará a cubrir facturas veterinarias pendientes y futuras, así como a la alimentación de los gatos.<br/>
        ¡Muchas gracias por vuestra confianza y apoyo!
        </Typography>
      </Container>

      <br></br>


      {/* Módulo de ayuda*/}
      <Box sx={{ backgroundColor: "#EDEDED", py: 0.5, pb: 4}}>
        <Container maxWidth="lg">
          <Typography variant="h6" align="center" sx={{ mt: 4, mb: 2, fontFamily: "Bitter, serif", fontWeight: "bold", color: "#383838" }}>
            ¿Cómo ayudar?
          </Typography>
          <Grid container spacing={3} justifyContent="center">
            <Grid item xs={12} sm={4}>
              <Box textAlign="center">
                <Typography variant="subtitle1" fontWeight="bold" sx={{ display: "flex", alignItems: "center", justifyContent: "left", color: '#383838' }}> 1️⃣ Teaming (1€ al mes)</Typography>
                <Typography variant="body2" sx={{ textAlign: 'justify'}} >Únete a nuestro grupo de Teaming y colabora con solo 1 € al mes para ayudarnos a continuar con nuestras actividades. <br/><a href="https://www.teaming.net/associaciobisbalgat-grupo?lang=es_ES" target="_blank" rel="noopener noreferrer">Enlace de nuestro teamer</a></Typography>
                </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box textAlign="center">
                <Typography variant="subtitle1" fontWeight="bold" sx={{ display: "flex", alignItems: "center", justifyContent: "left", color: '#383838'}}> 2️⃣ Donaciones al número de cuenta </Typography>
                <Typography variant="body2" sx={{ textAlign: 'justify'}}>Puedes hacer una donación directamente a nuestra cuenta bancaria para apoyar nuestros proyectos y atenciones veterinarias. <br/>ES34 0182 0199 9702 0180 4428 </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box textAlign="center">
                <Typography variant="subtitle1" fontWeight="bold" sx={{ display: "flex", alignItems: "center", justifyContent: "left", color: '#383838'}}> 3️⃣ PayPal</Typography>
                <Typography variant="body2" sx={{ textAlign: 'justify'}} >Haz tu donación de manera fácil y rápida a través de PayPal. <br/><a href="https://www.paypal.me/Bisbalgat?locale.x=es_ES" target="_blank" rel="noopener noreferrer">Haz clic aquí</a></Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box textAlign="center">
                <Typography variant="subtitle1" fontWeight="bold" sx={{ display: "flex", alignItems: "center", justifyContent: "left", color: '#383838'}}>  4️⃣ Bizum</Typography>
                <Typography variant="body2" sx={{ textAlign: 'justify'}} >Si te resulta más fácil, dona directamente desde tu móvil con Bizum <br/> ☎️ 618 29 36 61 </Typography>
                </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box textAlign="center">
                <Typography variant="subtitle1" fontWeight="bold" sx={{ display: "flex", alignItems: "center", justifyContent: "left", color: '#383838'}}> 5️⃣ Hazte socio/socia</Typography>
                <Typography variant="body2" sx={{ textAlign: 'justify'}}>Al asociarte, obtendrás descuentos en servicios veterinarios. Ponte en contacto por correo para saber cómo ser miembro. <br/> bisbalgat@yahoo.es </Typography>
                </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <br/>
      <br/>
    </Box>
  );
}

export default HelpUs;
